/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PuzzleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="puzzle"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M6.75 15.75A2.167 2.167 0 1 1 6.75 11.75" data-tinysvg-shape="arc" data-tinysvg-arc="5.917 13.75 2.167 2.167 67.38 292.62 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.75 6.75A2.167 2.167 0 1 1 15.75 6.75" data-tinysvg-shape="arc" data-tinysvg-arc="13.75 5.917 2.167 2.167 157.38 382.62 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.25 15.75A2.167 2.167 0 1 1 20.25 11.75" data-tinysvg-shape="arc" data-tinysvg-arc="19.417 13.75 2.167 2.167 67.38 292.62 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.75 20.25A2.167 2.167 0 1 1 15.75 20.25" data-tinysvg-shape="arc" data-tinysvg-arc="13.75 19.417 2.167 2.167 157.38 382.62 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.75 6.75L8.75 6.75C7.645 6.75 6.75 7.645 6.75 8.75L6.75 11.75" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6.75 15.75L6.75 18.25C6.75 19.355 7.645 20.25 8.75 20.25L11.75 20.25" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.75 20.25L18.25 20.25C19.355 20.25 20.25 19.355 20.25 18.25L20.25 15.75" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.25 11.75L20.25 8.75C20.25 7.645 19.355 6.75 18.25 6.75L15.75 6.75" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
